'use strict';

import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(document).ready(function () {
    $('#billable-error-form').on('submit', function (e) {
      e.preventDefault();

      const form = $(this);
      const url = form.attr('action');
      const formData = form.serialize();

      $.ajax({
        url,
        method: 'GET',
        data: formData,
        dataType: 'json',
        success(response) {
          $('#billable-error-response').show();
          $('#billable-error-response pre').text(JSON.stringify(response, null, 2));
        },
        error(xhr, status, error) {
          $('#billable-error-response').show();
          $('#billable-error-response pre').text('Error: ' + error + '\n\n' + xhr.responseText);
        },
      });
    });
  });
});
